import type { BlockConfig } from '../../../types'

export const BLOCK_CATALOG: BlockConfig[] = [
  {
    type: 'hero',
    label: 'Hero',
    icon: 'Image',
    description: 'Product image with headline',
    category: 'content',
    defaultProps: {
      headline: 'Wait! Special Offer Just For You',
      subheadline: 'Add this to your order at a special price',
      imageUrl: '',
      bgColor: '',
    },
  },
  {
    type: 'product-offer',
    label: 'Product Offer',
    icon: 'ShoppingCart',
    description: 'Product card with price and discount',
    category: 'commerce',
    defaultProps: {
      productName: 'Premium Product',
      originalPrice: '49.99',
      discountedPrice: '29.99',
      discountLabel: '40% OFF',
      imageUrl: '',
      showBadge: true,
    },
  },
  {
    type: 'product-gallery',
    label: 'Product Gallery',
    icon: 'GalleryHorizontal',
    description: 'Product image strip for PDP-like sections',
    category: 'media',
    defaultProps: {
      imageUrl1: '',
      imageUrl2: '',
      imageUrl3: '',
      columns: 3,
      gap: 8,
    },
  },
  {
    type: 'product-specs',
    label: 'Product Specs',
    icon: 'ListChecks',
    description: 'Feature list focused on product specifications',
    category: 'content',
    defaultProps: {
      feature1: 'Premium quality materials',
      feature2: 'Ships in 24 hours',
      feature3: '1-year warranty included',
      iconColor: '#22c55e',
    },
  },
  {
    type: 'reviews-widget',
    label: 'Reviews Widget',
    icon: 'MessageCircleHeart',
    description: 'Customer review snippet with rating',
    category: 'social-proof',
    defaultProps: {
      quote: '"Great quality and fast delivery. Highly recommended!"',
      author: 'Verified Buyer',
      rating: 5,
    },
  },
  {
    type: 'cta-section',
    label: 'CTA Section',
    icon: 'MousePointerClick',
    description: 'Primary/secondary actions for landing and popup flows',
    category: 'content',
    defaultProps: {
      acceptText: 'Add to my order',
      declineText: 'No thanks',
      acceptColor: '#22c55e',
      declineColor: '#ef4444',
    },
  },
  {
    type: 'cta',
    label: 'CTA Buttons',
    icon: 'MousePointerClick',
    description: 'Accept/Decline action buttons',
    category: 'content',
    defaultProps: {
      acceptText: 'Yes! Add to my order',
      declineText: "No thanks, I'll pass",
      acceptColor: '#22c55e',
      declineColor: '#ef4444',
    },
  },
  {
    type: 'discount-badge',
    label: 'Discount Badge',
    icon: 'Tag',
    description: 'Highlight savings amount',
    category: 'commerce',
    defaultProps: {
      text: 'SAVE 40%',
      bgColor: '#ef4444',
      textColor: '#ffffff',
    },
  },
  {
    type: 'timer',
    label: 'Urgency Timer',
    icon: 'Timer',
    description: 'Countdown timer for urgency',
    category: 'social-proof',
    defaultProps: {
      minutes: 5,
      message: 'This offer expires in:',
      bgColor: '',
    },
  },
  {
    type: 'testimonial',
    label: 'Testimonial',
    icon: 'MessageSquare',
    description: 'Customer quote/review',
    category: 'social-proof',
    defaultProps: {
      quote: '"This product changed my life! Best purchase I\'ve ever made."',
      author: 'Sarah M.',
      rating: 5,
    },
  },
  {
    type: 'text',
    label: 'Text Block',
    icon: 'Type',
    description: 'Custom text content',
    category: 'content',
    defaultProps: {
      content: 'Add your custom text here...',
      align: 'center',
      fontSize: '16',
    },
  },
  {
    type: 'image-gallery',
    label: 'Image Gallery',
    icon: 'Images',
    description: 'Multiple product images',
    category: 'media',
    defaultProps: {
      imageUrl1: '',
      imageUrl2: '',
      imageUrl3: '',
      columns: 3,
      gap: 8,
    },
  },
  {
    type: 'feature-list',
    label: 'Feature List',
    icon: 'ListChecks',
    description: 'List of product features',
    category: 'content',
    defaultProps: {
      feature1: 'Premium quality materials',
      feature2: '30-day money back guarantee',
      feature3: 'Free shipping included',
      iconColor: '#22c55e',
    },
  },
  {
    type: 'video-embed',
    label: 'Video Embed',
    icon: 'Play',
    description: 'Embedded video player',
    category: 'media',
    defaultProps: {
      videoUrl: '',
      autoplay: false,
      aspectRatio: '16:9',
    },
  },
  {
    type: 'image',
    label: 'Image',
    icon: 'ImageIcon',
    description: 'Single image block',
    category: 'media',
    defaultProps: {
      src: '',
      alt: 'Image',
      width: '100%',
    },
  },
  {
    type: 'divider',
    label: 'Divider',
    icon: 'Minus',
    description: 'Horizontal divider line',
    category: 'content',
    defaultProps: {
      color: '',
      thickness: '1',
    },
  },
  {
    type: 'countdown',
    label: 'Countdown Timer',
    icon: 'Clock',
    description: 'Countdown timer with label',
    category: 'social-proof',
    defaultProps: {
      minutes: '15',
      label: 'Offer expires in:',
      backgroundColor: '',
      textColor: '',
    },
  },
]

export function getBlockConfig(type: string): BlockConfig | undefined {
  return BLOCK_CATALOG.find((b) => b.type === type)
}

export const BLOCK_CATEGORIES = [
  { id: 'content', label: 'Content' },
  { id: 'commerce', label: 'Commerce' },
  { id: 'social-proof', label: 'Social Proof' },
  { id: 'media', label: 'Media' },
] as const
